import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';

import { environment } from '../../../environments/environment';

type JwtPayload = {
  sub: string;
  role: string;
  iat: number;
  exp: number;
  [k: string]: unknown;
};

function decodeJwt<T = any>(token: string): T | null {
  try {
    const [, payload] = token.split('.');
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);
  private cookies = inject(CookieService);
  private router = inject(Router);

  login(formValue: any) {
    return this.http.post(`${environment.apiUrl}/auth/login`, formValue, {
      observe: 'response',
    });
  }

  setAccessToken(token: string) {
    this.cookies.set('accessToken', token, {
      path: '/',
      secure: true,
      sameSite: 'Strict',
    });
  }

  getAccessToken() {
    return this.cookies.get('accessToken');
  }

  isUserLogged() {
    // TODO: add more functionality ??
    const token = this.getAccessToken();

    return !!token;
  }

  doesUserHasRole(roles: any) {
    const token = this.getAccessToken();
    const claims = token ? decodeJwt<JwtPayload>(token) : null;

    return (roles as Array<string>).includes(claims?.role || '');
    // return false;
  }

  logout() {
    this.cookies.delete('accessToken', '/');
    this.router.navigate(['/inicio-sesion']);
  }
}
